import { Region } from '@hiwaldo/sdk';
import {
  HydraBoostDailyFixture,
  HydraBoostDailyTrialFixture,
  VitaminBoostDailyFixture,
  VitaminBoostDailyTrialFixture,
} from '../fixtures';

export const getLensProductVariantSKU = (
  region: Region,
  productVariantId: number
): string => {
  let productVariants: any[];

  if (productVariantId <= 50) {
    productVariants = HydraBoostDailyFixture.productVariants;
  } else if (productVariantId > 50 && productVariantId <= 100) {
    productVariants = HydraBoostDailyTrialFixture.productVariants;
  } else if (productVariantId > 100 && productVariantId <= 150) {
    productVariants = VitaminBoostDailyFixture.productVariants;
  } else if (productVariantId > 150 && productVariantId <= 200) {
    productVariants = VitaminBoostDailyTrialFixture.productVariants;
  } else {
    throw new Error(
      `Could determine lens product variant SKU for id: ${productVariantId}`
    );
  }

  if (productVariants.length) {
    for (const x in productVariants) {
      if (productVariants[x].id === productVariantId) {
        for (const i in productVariants[x].locales) {
          if (productVariants[x].locales[i].region === region) {
            return productVariants[x].locales[i].sku;
          }
        }
      }
    }
  }

  throw new Error(
    `Could determine lens product variant SKU for id: ${productVariantId}`
  );
};
